import { ListBox } from "primereact/listbox";
import { getSelectedStudentStatuses, setSelectedStudentStatuses } from "../../services/students/studentsSlice";
import FilterCard from "./FilterCard";
import { Skeleton } from "primereact/skeleton";
import { Message } from "primereact/message";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../hooks/redux";
import { studentStatusesApi } from "../../services/nomenclatures/studentStatusesApi";

const StudentStatusFilter = (props: any) => {
  const selectedStudentStatuses = useSelector(getSelectedStudentStatuses);
  const dispatch = useAppDispatch();
  const { data: studentStatus, error, isLoading } = studentStatusesApi.useGetStudentStatusesQuery();

  if (isLoading) return <Skeleton className="w-full h-2rem" />;
  if (error) return <Message severity="error" text={JSON.stringify(error)} />;
  return (
    <FilterCard title="По статус на студент:">
      <ListBox
        value={selectedStudentStatuses}
        onChange={(e) => dispatch(setSelectedStudentStatuses(e.value))}
        options={studentStatus?.data ?? []}
        itemID="studentStatusId"
        optionLabel="name"
        filterPlaceholder=""
        emptyFilterMessage="Няма намерени резултати."
        multiple
        listClassName="max-h-24rem"
      />
    </FilterCard>
  );
};

export default StudentStatusFilter;
